<template>
  <el-dropdown
    placement="bottom"
    size="small"
    @command="onChangeLocale">
    <el-button class="d2-mr btn-text can-hover" style="font-size: 20px;" @click="drawerShow"
               type="text">
      <el-badge :value="orderList.length" class="item">
        <i class="fa fa-address-card"  style="font-size: 20px"></i>
<!--        <d2-icon-->
<!--          name="bell"-->
<!--          style="font-size: 20px"/>-->
      </el-badge>
    </el-button>
    <el-drawer
      title=""
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose">
      <el-table
        :data="orderList.filter(data => !search || data.roomCode.toLowerCase().includes(search.toLowerCase()) || data.userName.toLowerCase().includes(search.toLowerCase()) )"
      >
        <el-table-column label="用户昵称">
          <template slot-scope="scope">
            <el-tag>{{ scope.row.userName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column property="name" label="房间编号">
          <template slot-scope="scope">
            <el-tag>{{ scope.row.roomCode }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="right">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="search"
              size="mini"
              placeholder="联系方式或房间编号"/>
          </template>
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="updateRechargeOrderById(scope.$index, scope.row ,orderList)">同意
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>
  </el-dropdown>
</template>

<script>
import localeMixin from '@/locales/mixin.js'
import {mapActions, mapState} from "vuex";
import {findRechargeOrderByParams, updateRechargeOrderById} from "@/api/rechargeOrder";
import qs from "qs";

export default {
  mixins: [
    localeMixin
  ],
  data() {
    return {
      filename: __filename,
      search: '',
      orderList: [],
      direction: 'rtl',
      drawer: false,
      loading: false
    }
  },
  computed: {
    ...mapState('d2admin/logShow', [
      'active'
    ])
    // tooltipContent () {
    //   return this.orderList.length === 0
    //     ? '没有申请绑定用户'
    //     : `${this.orderList.length} 条日志${this.logLengthError > 0
    //       ? ` | 包含 ${this.logLengthError} 个异常`
    //       : ''}`
    // }
  },
  mounted() {
    let _this = this
    _this.findRechargeOrderByParams()
  },
  methods: {
    ...mapActions('d2admin/logShow', [
      'toggle'
    ]),
    drawerShow() {
      this.findRechargeOrderByParams()
      this.drawer = true
    },
    findRechargeOrderByParams() {
      console.log('findRechargeOrderByParams')
      let obj = {}
      obj.orderStatus = 1
      findRechargeOrderByParams(obj).then(res => {
        this.orderList = res.data
      }).catch(err => {
        this.$notify({
          title: '数据请求异常'
        })
        console.log('err', err)
      })
    },
    updateRechargeOrderById(index, row, rows) {
      let obj = {}
      obj.orderId = row.orderId
      obj.orderStatus = 0
      updateRechargeOrderById(qs.stringify(obj)).then(res => {
        rows.splice(index, 1)
      }).catch(err => {
        console.log(err)
      })
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {
        });
    }
  }
}
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-locales/index.vue"
}
</vue-filename-injector>
